import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, nextTick } from 'vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import STable from '@/components/Table/index.vue'
import { t } from '@/plugins/i18n'
import { ElMessageBox, ElMessage } from 'element-plus'
import { editMeasureSizeHistoryApi } from '@/apis/goods'
import { useStore } from 'vuex'
import { getJapanTime } from '@/util/common'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const visible = ref(false)
const cancel = () => {
  visible.value = false
}
const columns = ref([
  {
    label: t('修改内容'),
    prop: 'content',
    align: 'center'
  },
  {
    label: t('操作时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  }
])
const pageData = ref({
  pageSize: 10,
  pageNum: 1
})
const filterData = ref({
  productMeasureId: ''
})
const STableRef = ref()
expose({
  open: (record: any) => {
    filterData.value.productMeasureId = record.id
    visible.value = true
    nextTick(() => {
      STableRef.value && STableRef.value.getData()
    })
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonDialog, {
    onCancel: cancel,
    className: "edit-measure-modal",
    visible: visible.value,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    width: 600,
    "append-to-body": "",
    "modal-class": "edit-measure-modal",
    title: _unref(t)('操作日志')
  }, {
    default: _withCtx(() => [
      _createVNode(STable, {
        ref: (_value, _refs) => {
          _refs['STableRef'] = _value
          STableRef.value = _value
        },
        "page-data": pageData.value,
        "onUpdate:page-data": _cache[0] || (_cache[0] = ($event: any) => ((pageData).value = $event)),
        api: _unref(editMeasureSizeHistoryApi),
        filterData: filterData.value,
        columns: columns.value
      }, {
        createTime: _withCtx(({row}) => [
          _createTextVNode(_toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
        ]),
        _: 1
      }, 8, ["page-data", "api", "filterData", "columns"])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})